const tr = {
  activeClients: {
    attributes: {
      id: 'ID',
      username: 'Nome do usuário',
      document: 'CPF',
      holder: 'Titular',
      company: 'Empresa',
      plan: 'Plano',
      bindingDate: 'Data de vínculo',
      planExpiredDate: 'Data Vencimento Plano',
      dateExclusion: 'Data da Exclusão',
      specialty: 'Especialidade',
    },
    extras: {
      search: 'Digite o nome do usuário',
      date_init: 'Data inicial',
      date_end: 'Data final',
      planType: 'Tipo de Plano',
      specialty: 'Especialidade',
      justExpiredPlans: 'Somente planos vencidos',
      userRemovedViaApp: 'Usuários Excluídos via App',
      situationFilter: 'Situação',
    },
    defSingular: 'Cliente ativo',
    defPlural: 'Clientes ativos',
  },
};

export default tr;
